<div class="eui-header-logo-wrapper">
    <ng-content select="eui-header-logo"></ng-content>
    <ng-content select="eui-header-environment"></ng-content>
</div>

<ng-content select="eui-header-app"></ng-content>

<div class="eui-header-right-content">
    <ng-content select="eui-header-user-profile"></ng-content>
    <eui-language-selector></eui-language-selector>
</div>

